var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discount"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Light",
    opacity: 0.2,
    d: "M63.3388 17.114C70.3468 11.1419 80.654 11.1419 87.662 17.114L91.9283 20.7498C94.9314 23.309 98.6653 24.8556 102.598 25.1695L108.186 25.6154C117.364 26.3478 124.653 33.6361 125.385 42.8144L125.831 48.4021C126.145 52.3352 127.691 56.069 130.251 59.0721L133.886 63.3385C139.859 70.3464 139.859 80.6537 133.886 87.6616L130.251 91.9279C127.691 94.931 126.145 98.6649 125.831 102.598L125.385 108.186C124.653 117.364 117.364 124.652 108.186 125.385L102.598 125.831C98.6653 126.144 94.9314 127.691 91.9283 130.25L87.662 133.886C80.654 139.858 70.3468 139.858 63.3388 133.886L59.0725 130.25C56.0694 127.691 52.3355 126.144 48.4024 125.831L42.8148 125.385C33.6365 124.652 26.3482 117.364 25.6157 108.186L25.1698 102.598C24.856 98.6649 23.3094 94.931 20.7502 91.928L17.1144 87.6616C11.1423 80.6537 11.1423 70.3464 17.1144 63.3385L20.7502 59.0721C23.3094 56.069 24.856 52.3352 25.1698 48.4021L25.6157 42.8144C26.3482 33.6361 33.6365 26.3478 42.8148 25.6154L48.4024 25.1695C52.3355 24.8556 56.0694 23.309 59.0725 20.7498L63.3388 17.114Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0004 56.75C63.0004 60.2018 60.2022 63 56.7504 63C53.2986 63 50.5004 60.2018 50.5004 56.75C50.5004 53.2982 53.2986 50.5 56.7504 50.5C60.2022 50.5 63.0004 53.2982 63.0004 56.75Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5 94.25C100.5 97.7018 97.7022 100.5 94.2504 100.5C90.7986 100.5 88.0004 97.7018 88.0004 94.25C88.0004 90.7982 90.7986 88 94.2504 88C97.7022 88 100.5 90.7982 100.5 94.25Z",
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5649 53.4354C99.3955 55.266 99.3955 58.234 97.5649 60.0646L60.0649 97.5646C58.2344 99.3951 55.2664 99.3951 53.4358 97.5646C51.6052 95.734 51.6052 92.766 53.4358 90.9354L90.9358 53.4354C92.7664 51.6049 95.7344 51.6049 97.5649 53.4354Z",
    fill: "#6B47F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.019b8e629c2cf64c0e9b513cf8f6fb63.svg";
export { ForwardRef as ReactComponent };